import { Link } from "react-router-dom";

export const Fill = ({ children }) => (
  <mark data-testid="legal-placeholder" className="rounded bg-[#FFF0C2] px-1 font-semibold text-[color:var(--espresso)]">[À compléter : {children}]</mark>
);

export function LegalLayout({ title, testId, children }) {
  return (
    <main data-testid={testId} className="mx-auto max-w-3xl px-4 pb-16 pt-10 sm:px-8">
      <h1 className="font-display text-4xl font-bold sm:text-5xl">{title}</h1>
      <p className="mt-2 text-sm text-[color:var(--muted-ink)]">Dernière mise à jour : juin 2026 · version 2026-06</p>
      <div className="legal mt-8 space-y-8 text-[17px] leading-relaxed [&_h2]:font-display [&_h2]:text-2xl [&_h2]:font-bold [&_h2]:mb-2 [&_ul]:list-disc [&_ul]:pl-6 [&_ul]:space-y-1 [&_a]:font-bold [&_a]:underline">
        {children}
      </div>
    </main>
  );
}

export const Section = ({ title, children }) => <section><h2>{title}</h2>{children}</section>;
export const L = ({ to, children }) => <Link to={to}>{children}</Link>;
